import { render, staticRenderFns } from "./RootNode.vue?vue&type=template&id=800dc88c&scoped=true"
import script from "./RootNode.vue?vue&type=script&lang=js"
export * from "./RootNode.vue?vue&type=script&lang=js"
import style0 from "./RootNode.vue?vue&type=style&index=0&id=800dc88c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800dc88c",
  null
  
)

export default component.exports